import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileAccessService {
  public getFileUrl(botId: string, skillId: string): string {
    const normalizedBotId = botId.trim();
    const normalizedSkillId = skillId.trim();
    if (!normalizedBotId) {
      throw new Error('Eine Bot-ID ist erforderlich, um die Datei zu öffnen.');
    }
    if (!normalizedSkillId) {
      throw new Error('Eine Skill-ID ist erforderlich, um die Datei zu öffnen.');
    }
    return `${window.location.origin}/api/toolbox/bot/file/${encodeURIComponent(normalizedBotId)}/${encodeURIComponent(normalizedSkillId)}`;
  }
}
